import React from 'react'
import Navbar from '../../components/Navbar'
import SmallFooter from '../../components/SmallFooter'

const Profile = () => {
    const [data, setData] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(false)

    const loadBuyerData = () => {
        fetch(process.env.REACT_APP_SERVER_URL + '/buyer/isloggedin', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        })
            .then(res => res.json())
            .then(res => {
                console.log(res)
                setData(res.buyer)
                setIsLoading(false)
            })
            .catch(err => console.log(err))
    }

    React.useEffect(() => {
        setIsLoading(true)
        loadBuyerData()
    }, [])

    return (
        <div className='dark:bg-black dark:text-white min-h-screen'>
            <Navbar /> {
                isLoading ?
                    null
                    :
                    <div className="relative dark:bg-black  shadow dark:shadow-gray-400 sm:rounded-lg lg:mx-32 mt-2">
                        <div className="px-4 py-5 sm:px-6">
                            <h3 className="text-lg dark:bg-black  font-medium leading-6 dark:text-white text-gray-900">Applicant Information</h3>
                            <p className="mt-1 max-w-2xl text-sm  text-gray-500 dark:bg-black dark:text-gray-400">Personal details and application.</p>
                        </div>
                        <div className="border-t border-gray-200 dark:bg-black dark:border-gray-400 ">
                            <dl>
                                <div className=" bg-white px-4 py-5 dark:bg-black dark:text-white sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        Name
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        {data.name}
                                    </dd>
                                </div>
                                <div className="dark:bg-black bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        Username
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        {data.username}
                                    </dd>
                                </div>
                                <div className="dark:bg-black bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        Email
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        {data.email}
                                    </dd>
                                </div>
                                <div className="dark:bg-black bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        Total Purchases
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        ₹  {data.price}
                                    </dd>
                                </div>
                                <div className="dark:bg-black bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium dark:text-white text-gray-500">
                                        Password
                                    </dt>
                                    <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:mt-0 sm:col-span-2">
                                        *********
                                    </dd>
                                </div>
                            </dl>
                            {/* <div className="dark:bg-black bg-white px-4 py-5 grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="text-sm font-medium dark:text-white text-gray-500"></dt>
                                <dd className="mt-1 text-sm dark:text-white text-gray-900 sm:col-span-2 sm:mt-0 space-x-10">
                                    <button className="bg-blue-400 hover:bg-blue-500 text-white font-bold py-2 px-4 rounded">
                                        Edit Information
                                    </button>
                                    <button className="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 rounded">
                                        Delete Account
                                    </button>
                                </dd>
                            </div> */}
                        </div>
                    </div>
            }


            <div className='absolute w-full bottom-0'>
                <SmallFooter />
            </div>
        </div>
    )
}

export default Profile